export let env;
export function init(e) {
    env = Object.assign(Object.assign({}, e), { buildInfo: CORTI_BUILD });
}
